export default  {
    component: 'breaker',
    name: 'breaker',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, room id should start from **"1"**`
          },
          {
            name: 'Room ID',
            param: 'room_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, room id should start from **"1"**`
          },
          {
            name: 'Breaker ID',
            param: 'breaker_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block-room, breaker id should start from **"1"**`
          },
          {
            name: 'Breaker Name',
            param: 'breaker_name',
            type: 'text',
            description: `> For each block-room breaker name should be unique`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> The concatination for ID's block-room-device *\(e.g. 1-1-1)`
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-efficiency,rm-voltage_supply)`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
          },
          {
            name: 'Reading Frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          }
    ]
  }




